import {EnumQuoteServiceType} from "../../../../enum/enum-quote-service-type";
import {DiscoVtPricingItemMapper} from "../disco-vt-pricing-item.mapper";
import {DiscoPricingItemMapper} from "../disco-pricing-item.mapper";
import { DiscoLsPricingItemMapper } from '../disco-ls-pricing-item.mapper';
import { DiscoDasriPricingItemMapper } from "../disco-dasri-pricing-item.mapper";

export class PricingItemMapperFactory {
    static create(serviceCode: string): DiscoPricingItemMapper {
        if (serviceCode === EnumQuoteServiceType.VT) {
            return new DiscoVtPricingItemMapper(true);
        }else if (serviceCode === EnumQuoteServiceType.LS) {
            return new DiscoLsPricingItemMapper(true);
        }else if (serviceCode === EnumQuoteServiceType.DASRI) {
            return new DiscoDasriPricingItemMapper(true);
        }
        return new DiscoPricingItemMapper(true);
    }
}
